export default __webpack_public_path__ + "static/media/dra-preguntas.d779cb7c.png";